import xhr from '../utilities/xhr';
import {
    START_LOADING_SESSION,
    END_LOADING_SESSION,
    START_LOGGING_IN,
    END_LOGGING_IN
} from '../constants';

import {
    AppDispatch,
    persistor
} from '~/frontend/src/store';
import webSocket from '~/frontend/src/utilities/webSocket';
import {load as configLoad} from '~/frontend/src/actions/config';
import {load as metaModelLoad} from '~/frontend/src/actions/metamodel';
import {load as messageCatalogLoad} from '~/frontend/src/actions/messagecatalog';
import setUser from '~/frontend/src/actions/user/setUser';
import unsetUser from '~/frontend/src/actions/user/unsetUser';
import {clearAllElusiveData} from '~/frontend/src/actions/elusiveData';


/**
 * @memberOf! Actions
 *
 * @return {function}
 */
export const loadSession = () => load();

export type StartLoadSession = {
    type : typeof START_LOADING_SESSION;
}
const startLoadSession = () : StartLoadSession => {
    return {
        type: START_LOADING_SESSION
    };
}

export type EndLoadSession = {
    type : typeof END_LOADING_SESSION;
}
const endLoadSession = () : EndLoadSession => {
    return {
        type: END_LOADING_SESSION
    };
}

/**
 * @memberOf! Actions
 *
 * @param {string} username
 * @param {string} password
 *
 * @return {function}
 */
export const login = ( username : string, password : string ) => load( username, password );

export default login;

export type StartLoginAction = {
    type : typeof START_LOGGING_IN;
}

/**
 * @memberOf! Actions
 *
 * @return {function}
 */
const startLogin = () : StartLoginAction => {
    return {
        type: START_LOGGING_IN
    };
};

export type EndLoginAction = {
    type : typeof END_LOGGING_IN;
}

/**
 * @memberOf! Actions
 *
 * @return {function}
 */
const endLogin = () : EndLoginAction => {
    return {
        type: END_LOGGING_IN
    };
};

/**
 *
 * @param username
 * @param password
 */
const load = ( username = '', password = '' ) => ( dispatch : AppDispatch ) => {
    doLoad( username, password, dispatch ).catch( ( error ) => {
        console.log( error );
    } );
};

/**
 * Loads the user data from the backend via login or user/load
 */
const doLoad = async ( username = '', password = '', dispatch : AppDispatch ) : Promise<void> => {
    let result,
        userData;

    // login user
    if ( username !== '' ) {
        dispatch( clearAllElusiveData() );
        dispatch( startLogin() );

        result = await xhr.post(
            `${BASE_URL}/login`,
            {
                username,
                password
            },
            undefined,
            'login',
            'login',
            dispatch
        );
    }
    // load user
    else {
        dispatch( startLoadSession() );

        result = await xhr.post(
            `${BASE_URL}/api/user/load`,
            undefined,
            undefined,
            'login',
            'load',
            dispatch
        );
    }

    // handle user result
    if ( result?.data?.success && result.data.user ) {
        userData = result.data.user;

        // load globals
        await dispatch( configLoad() );
        await dispatch( metaModelLoad() );
        await dispatch( messageCatalogLoad() );

        // init user
        dispatch( setUser( userData ) );

        localStorage.setItem( 'lastUser', userData.userId );

        webSocket.init();

        // start persistor -> this will lift the PersistGate
        persistor.persist();
    }
    else if ( username !== '' ) {
        dispatch( unsetUser() );
    }

    if ( username !== '' ) {
        dispatch( endLogin() );
    }
    else {
        dispatch( endLoadSession() );
    }
};
